import { useCallback, useEffect, useState } from "react";
import PurchaseOrderHistory from "./PurchaseOrderHistory";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import { getFleetPurchaseOrderHistory } from "Store/FleetManagement/FleetPurchaseOrderHistory/FleetPurchaseOrderHistoryAction";

const PurchaseOrderHistoryContainer = (props: any) => {

  const {
    poNumber,
    fleetRequestDetailId
  } = props;

  const {
    fleetPurchaseOrderHistory
  } = useSelector((state: any) => ({
    fleetPurchaseOrderHistory: state.FleetPurchaseOrderHistoryReducers.fleetPurchaseOrderHistory
  }));

  const dispatch = useDispatch();
  const [paginationData, setPaginationData] = useState<any>({});
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [serverTotal, setServerTotal] = useState(0);
  const [tableData, setTableData] = useState<any>([]);

  useEffect(() => {
    if (fleetPurchaseOrderHistory?.length) {
      let tempData = fleetPurchaseOrderHistory?.find(
        (item: any) => item?.id == fleetRequestDetailId
      );
      if (tempData?.isOpen) {
        setTableData(tempData?.response?.data);
        setServerTotal(tempData?.response?.totalRecords);
      }
    }
  }, [fleetPurchaseOrderHistory])

  const columns = [
    {
      key: "requestedDate",
      title: "Request Date (PST)",
      width: 120,
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row?.rowData?.requestedDate
              ? Moment(row?.rowData?.requestedDate).format("MM/DD/YYYY HH:mm:ss A")
              : ""}
          </p>
        );
      },
    },
    {
      key: "requestedBy",
      title: "Request By",
      width: 120,
    },
    {
      key: "purchaseOrderLink",
      title: "Purchase Order Link",
      width: 120,
      Cell: (row: any) => {
        return (
          <a className="view-link"
            onClick={(e: any) =>
              onClickPdfLink(e, row?.rowData?.purchaseOrderLink)
            }
          >
            Review Purchase Order
          </a>
        )
      },
    },
  ];

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize;
      let tempPageCount =
        serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0;
      setPagesCount(tempPageCount);
    }
  }, [serverTotal, paginationData?.pageSize]);

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      setPaginationData(fetchData.data);
      dispatch(
        getFleetPurchaseOrderHistory({
          fleetDetailId: fleetRequestDetailId,
          poNumber: poNumber,
          pageNumber:
            fetchData?.data?.pageIndex != undefined
              ? fetchData?.data?.pageIndex + 1
              : undefined,
          pageSize: fetchData?.data?.pageSize,
        })
      );
    }
  }, []);

  const onClickPdfLink = (e?: any, purchaseOrderLink?: any) => {
    e?.preventDefault();
    let win = window.open();
    if (win) {
      win.document.write(
        '<iframe width="100%" height="100%" src="' +
        purchaseOrderLink +
        '" frameborder="0" ></iframe>'
      );
    }
  }

  return (
    <PurchaseOrderHistory
      columns={columns}
      fetchAction={fetchAction}
      pagesCount={pagesCount}
      serverTotal={serverTotal}
      data={tableData}
    />
  );
};

export default PurchaseOrderHistoryContainer;
